import React, { useState } from 'react';
import i18n from 'i18next';

import { Typo } from 'uikit/content';
import { Button } from 'uikit/buttons';
import { TextInput, Checkbox } from 'uikit/inputs';

import { copyToClipboard } from '@/exceed';

import 'react-toastify/dist/ReactToastify.css';

import styles from '../styles/videoBookmark.module.scss';

const VideoBookmark = ({ timestamp, videoId }) => {
  const { origin } = window.location;
  const timeQuery = timestamp ? `${Math.round(timestamp)}` : 0;
  const url = `${origin}/student/videos/on-demand/${videoId}`;

  const initialTime =
    timestamp < 3600
      ? new Date(timestamp * 1000).toISOString().slice(14, 19)
      : new Date(timestamp * 1000).toISOString().slice(11, 19);

  const [query, setQuery] = useState(timeQuery);
  const [time, setTime] = useState(initialTime || 0);
  const [timestampEnabled, setTimestampEnabled] = useState(false);

  const convertMMSStoSeconds = ({ value }) => {
    const timeArray = value.split(':');
    const seconds =
      timeArray.length === 3
        ? +timeArray[0] * 60 * 60 + +timeArray[1] * 60 + +timeArray[2]
        : +timeArray[0] * 60 + +timeArray[1];

    return seconds;
  };

  const onInputChanged = (value) => {
    setQuery(convertMMSStoSeconds({ value }));
    setTime(value);
  };

  const onCopyLinkClicked = () => {
    copyToClipboard(`${url}${timestampEnabled ? `?t=${query}` : ''}`);
  };

  return (
    <div className={styles.element}>
      <Typo className={styles.heading} variant="s02" weight="medium">
        {i18n.t('bookmark-link-to-copy')}
      </Typo>
      <div className={styles.url}>
        <Typo variant="s01">{`${url}${timestampEnabled ? `?t=${query}` : ''}`}</Typo>
        <Button icon="copyLink" onClick={onCopyLinkClicked} variant="ghost" size="small" />
      </div>
      <div className={styles.actions}>
        <Checkbox
          className={styles.checkbox}
          checkedIcon="checkBox"
          onChange={(value) => setTimestampEnabled(value)}
          value={timestampEnabled}
        />
        <Typo className={styles.startAt} variant="s02">
          {i18n.t('start-at')}
        </Typo>
        <TextInput
          className={styles.timeInput}
          value={time}
          onChange={onInputChanged}
          label={i18n.t('start-at')}
          isDisabled={!timestampEnabled}
        />
      </div>
    </div>
  );
};

export default VideoBookmark;
